import React from 'react';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const AGBPage: React.FC = () => {
  return (
    <Layout
      title="AGB | StimmDigital - Allgemeine Geschäftsbedingungen"
      description="Allgemeine Geschäftsbedingungen von StimmDigital für Software-Entwicklung und digitale Dienstleistungen"
      keywords="AGB, Geschäftsbedingungen, Vertrag, Software-Entwicklung, StimmDigital"
      showBreadcrumbs={true}
    >
      <section className="wrapper">
        <div className="page-container">
          <div className="page-header">
            <span className="section-title">Rechtliches</span>
            <h1>Allgemeine Geschäftsbedingungen</h1>
            <p>Gültig für alle Dienstleistungen von StimmDigital</p>
          </div>

          <div className="page-content-card">
            
            <h2 id="geltungsbereich">§ 1 Geltungsbereich</h2>
            <p>
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen Stimm Digital GmbH & Co. KG (nachfolgend "Auftragnehmer") und dem Kunden über die Erbringung von Dienstleistungen im Bereich Software-Entwicklung, Webentwicklung und IT-Beratung.
            </p>
            <p>
              Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann und insoweit Vertragsbestandteil, als ihrer Geltung ausdrücklich zugestimmt wurde.
            </p>

            <h2 id="vertragsschluss">§ 2 Vertragsschluss</h2>
            <p>
              Angebote des Auftragnehmers sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich bezeichnet sind.
            </p>
            <p>
              Der Vertrag kommt durch schriftliche Auftragsbestätigung des Auftragnehmers oder durch Beginn der Arbeiten zustande.
            </p>

            <h2 id="leistungen">§ 3 Leistungen</h2>
            <h3>3.1 Leistungsumfang</h3>
            <p>
              Der Umfang der zu erbringenden Leistungen ergibt sich aus dem jeweiligen Vertrag bzw. der Auftragsbestätigung. Änderungen oder Ergänzungen bedürfen der Schriftform.
            </p>
            
            <h3>3.2 Mitwirkungspflichten</h3>
            <p>
              Der Kunde ist verpflichtet, alle erforderlichen Informationen, Unterlagen und Zugänge rechtzeitig zur Verfügung zu stellen. Verzögerungen durch fehlende Mitwirkung gehen zu Lasten des Kunden.
            </p>

            <h3>3.3 Änderungswünsche</h3>
            <p>
              Änderungswünsche des Kunden nach Projektbeginn werden gesondert berechnet. Der Auftragnehmer ist berechtigt, für solche Änderungen einen angemessenen Aufpreis zu verlangen.
            </p>

            <h2 id="preise">§ 4 Preise und Zahlungsbedingungen</h2>
            <h3>4.1 Preise</h3>
            <p>
              Es gelten die zum Zeitpunkt des Vertragsschlusses vereinbarten Preise. Alle Preise verstehen sich zzgl. der gesetzlichen Mehrwertsteuer.
            </p>

            <h3>4.2 Zahlungsmodalitäten</h3>
            <p>
              Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zur Zahlung fällig. Bei Verzug werden Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz berechnet.
            </p>

            <h3>4.3 Anzahlungen</h3>
            <p>
              Der Auftragnehmer ist berechtigt, vor Projektbeginn eine Anzahlung in Höhe von bis zu 50% der Gesamtauftragssumme zu verlangen.
            </p>

            <h2 id="termine">§ 5 Termine und Fristen</h2>
            <p>
              Termine und Fristen sind nur dann verbindlich, wenn sie ausdrücklich als verbindlich vereinbart wurden. Der Auftragnehmer haftet nicht für Verzögerungen, die durch höhere Gewalt oder mangelnde Mitwirkung des Kunden entstehen.
            </p>

            <h2 id="urheberrecht">§ 6 Urheberrecht und Nutzungsrechte</h2>
            <h3>6.1 Urheberrecht</h3>
            <p>
              Alle im Rahmen des Auftrags entwickelten Programme, Designs und sonstigen Werke unterliegen dem Urheberrecht des Auftragnehmers.
            </p>

            <h3>6.2 Nutzungsrechte</h3>
            <p>
              Der Kunde erhält nach vollständiger Bezahlung die erforderlichen Nutzungsrechte zur vertragsgemäßen Nutzung der erstellten Software bzw. Website.
            </p>

            <h3>6.3 Quellcode</h3>
            <p>
              Ein Anspruch auf Herausgabe des Quellcodes besteht nur bei ausdrücklicher vertraglicher Vereinbarung.
            </p>

            <h2 id="haftung">§ 7 Haftung</h2>
            <h3>7.1 Haftungsausschluss</h3>
            <p>
              Der Auftragnehmer haftet nur für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit oder aus der Verletzung wesentlicher Vertragspflichten resultieren.
            </p>

            <h3>7.2 Datenverlust</h3>
            <p>
              Für Datenverlust haftet der Auftragnehmer nur, soweit dieser nicht durch zumutbare Datensicherungsmaßnahmen des Kunden hätte vermieden werden können.
            </p>

            <h2 id="gewaehrleistung">§ 8 Gewährleistung</h2>
            <p>
              Der Auftragnehmer gewährleistet die vertragsgemäße Beschaffenheit der erbrachten Leistungen. Die Gewährleistungsfrist beträgt 12 Monate ab Abnahme bzw. Übergabe.
            </p>
            <p>
              Mängel sind unverzüglich schriftlich anzuzeigen. Der Auftragnehmer ist zunächst zur Nacherfüllung berechtigt.
            </p>

            <h2 id="vertraulichkeit">§ 9 Vertraulichkeit</h2>
            <p>
              Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit erhaltenen vertraulichen Informationen streng vertraulich zu behandeln und nicht an Dritte weiterzugeben.
            </p>

            <h2 id="schlussbestimmungen">§ 10 Schlussbestimmungen</h2>
            <h3>10.1 Anwendbares Recht</h3>
            <p>
              Auf alle Rechtsbeziehungen zwischen dem Auftragnehmer und dem Kunden findet das Recht der Bundesrepublik Deutschland Anwendung.
            </p>

            <h3>10.2 Gerichtsstand</h3>
            <p>
              Gerichtsstand für alle Streitigkeiten ist Berlin, sofern der Kunde Kaufmann ist.
            </p>

            <h3>10.3 Salvatorische Klausel</h3>
            <p>
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
            </p>

            <div style={{ 
              marginTop: '3rem', 
              padding: '1.5rem',
              background: 'var(--gray-100)',
              borderRadius: '0.5rem',
              fontSize: '0.9rem',
              color: 'var(--gray-600)'
            }}>
              <p><strong>Stand:</strong> Dezember 2025</p>
              <p><strong>Stimm Digital GmbH & Co. KG</strong><br />
              Rheinstr. 2-3<br />
              12159 Berlin</p>
            </div>

            <div style={{ 
              marginTop: '3rem', 
              textAlign: 'center',
              padding: '2rem',
              background: 'var(--primary-color)',
              borderRadius: '0.5rem',
              color: 'white'
            }}>
              <h3>Fragen zu den AGB?</h3>
              <p>Kontaktiere uns gerne bei Fragen zu unseren Geschäftsbedingungen.</p>
              <button 
                className="secondary-button" 
                data-action="contact"
                style={{ 
                  background: 'white !important', 
                  color: '#0A8370 !important',
                  border: 'none !important'
                }}
              >
                Kontakt aufnehmen
                <i className="fas fa-envelope"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AGBPage;
